
















import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import { HashIcon, TrendingUpIcon } from 'vue-feather-icons';
import { FormatMixin } from '@/mixins/FormatMixin';
import { mixins } from 'vue-class-component';

@Component({
  components: { HashIcon, TrendingUpIcon },
})
export default class BasicStatisticCard extends mixins(FormatMixin) {
  @Prop({ required: true, type: String })
  label!: string;

  @Prop({ required: true, type: String })
  value!: string;
}
